import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../common/hooks/useAuth";
import useRefreshToken from "../../common/hooks/useRefreshToken";
import LandingPage from "./LandingPage";

const LandingGate = () => {
  const { auth } = useAuth();
  const refresh = useRefreshToken();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        if (!auth?.accessToken) {
          await refresh();
        }
      } catch (err) {
        if (isMounted) setHasError(true);
      } finally {
        if (isMounted) setIsChecking(false);
      }
    };

    checkAuth();
    return () => {
      isMounted = false;
    };
  }, [auth?.accessToken, refresh]);

  // Another tab logged in (coordinated login cache) -> pick up session cookie
  useEffect(() => {
    const onStorage = async (event) => {
      if (!event.key?.startsWith("vt_login_lock:") || !event.newValue) {
        return;
      }
      try {
        await refresh();
      } catch {
        // Still not logged in on this tab
      }
    };

    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [refresh]);

  if (auth?.accessToken) {
    return <Navigate to="/market-profile" state={{ from: location }} replace />;
  }

  if (isChecking && !hasError) {
    return null;
  }

  return <LandingPage />;
};

export default LandingGate;


